import { getCookie } from "@insite/client-framework/Common/Cookies";

export const wcTranslationCookieName = "wc_translation";

export interface WcTranslationPayload {
    shipToId?: string | null; // Stores bill-to value (renamed from billToId)
    branchId?: string | null;
}

export function parseWcTranslationCookie(): WcTranslationPayload | undefined {
    if (IS_SERVER_SIDE) {
        return undefined;
    }
    const raw = getCookie(wcTranslationCookieName);
    if (!raw) {
        return undefined;
    }
    try {
        const parsed = JSON.parse(raw) as WcTranslationPayload;
        const isValid = parsed && typeof parsed === "object";
        if (isValid) {
            return parsed;
        }
        return undefined;
    } catch (e) {
        console.error("Failed to parse cookie", e);
        return undefined;
    }
}
